import { createRouter, createWebHistory, type RouteLocationNormalized } from "vue-router";
import auth from "@/services/Auth";
import { useUserStore } from "@/stores/userStore";

const legacyPaths: Record<string, string> = {
  "/new": "/",
  "/new/deploy": "/deploy",
  "/new/automation": "/automation",
  "/new/insights": "/insights",
  "/new/admin/projects": "/admin/projects",
  "/new/admin/operations": "/admin/operations",
  "/new/admin/reconciliation": "/admin/reconciliation",
  "/new/admin/permissions": "/admin/permissions",
  "/dashboard": "/insights",
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: () => import("@/redesign/layout/AppShell.vue"),
      children: [
        { path: "", name: "environments", component: () => import("@/redesign/views/EnvironmentsView.vue") },
        { path: "deploy", name: "deploy", component: () => import("@/redesign/views/DeployView.vue") },
        { path: "automation", name: "automation", component: () => import("@/redesign/views/AutomationView.vue") },
        { path: "insights", name: "insights", component: () => import("@/redesign/views/InsightsView.vue"), meta: { requiresAdmin: true } },
        { path: "admin/projects", name: "projects-admin", component: () => import("@/redesign/views/ProjectsAdminView.vue"), meta: { requiresAdmin: true } },
        { path: "admin/operations", name: "operations-admin", component: () => import("@/redesign/views/OperationsView.vue"), meta: { requiresAdmin: true } },
        { path: "admin/reconciliation", name: "reconciliation", component: () => import("@/redesign/views/ReconciliationView.vue"), meta: { requiresAdmin: true } },
        { path: "admin/permissions", name: "permissions", component: () => import("@/views/PermissionsView.vue"), meta: { requiresAdmin: true } },
      ],
    },
    ...Object.entries(legacyPaths).map(([path, target]) => ({
      path,
      redirect: (to: RouteLocationNormalized) => {
        const query = { ...to.query };
        if (query.projectId != null && query.project == null) {
          query.project = query.projectId;
        }

        delete query.projectId;
        delete query.provider;
        return { path: target, query, hash: to.hash };
      },
    })),
    { path: "/sign-in", name: "sign-in", component: () => import("@/views/SignInView.vue") },
    { path: "/sign-in-failed", name: "sign-in-failed", component: () => import("@/views/SignInFailedView.vue") },
  ],
});

router.beforeEach(async (to) => {
  if (to.name === "sign-in-failed") {
    return true;
  }

  if (!auth.initialized) {
    await auth.initialize();
  }

  if (!auth.account) {
    try {
      await auth.login();
    } catch {
      return false;
    }
  }

  if (to.meta.requiresAdmin && auth.account) {
    await useUserStore().checkAdminStatus();
  }

  return true;
});

export default router;
